import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

// Could potentially be passed in as an .env var?
const paymentLimit = 25000;

export const formFields = {
  amount: {
    donationLabel: 'Enter another amount',
    id: 'amount',
    type: 'number',
  },
};

export const getMinimumDonationErrorMessage = (isAARN = false) => {
  const minimumDonation = isAARN ? 8 : 1;

  // "|" pipes are being used as a flag in these messages. It triggers different layout, don't delete.
  const minimumDonationErrorMessage = `Please check your donation|You can only donate between £${minimumDonation}.00 and £${paymentLimit.toLocaleString()}.00 at a time. If you need help, contact us.`;

  const minimumDonationErrorAARN = `Please check your subscription|A monthly amount between £${minimumDonation}.00 and £${paymentLimit.toLocaleString()}.00 is required to subscribe. If you need help, contact us.`;

  return isAARN ? minimumDonationErrorAARN : minimumDonationErrorMessage;
};

export const getRules = (isAARN = false) => {
  const minimumDonation = isAARN ? 8 : 1;
  const minimumErrorMessage = getMinimumDonationErrorMessage(isAARN);
  const paymentLimitErrorMessage = `Please check your donation|You can only donate between £1.00 and £${paymentLimit.toLocaleString()}.00 at a time. If you need help, contact us.`;

  return {
    [formFields.amount.id]: yup
      .number()
      .transform((value: number) => (Number.isNaN(value) ? undefined : value))
      .positive('Please enter the donation amount')
      .required('Please enter the donation amount')
      // As per the previous build:
      // https://github.com/comicrelief/react-donation/blob/089a3c759141f3a56f182b5d8db284548148689a/src/Pages/DonationForm/DonationForm.js#L42
      .min(minimumDonation, minimumErrorMessage)
      .max(paymentLimit, paymentLimitErrorMessage)
  };
};

export const getFormSchema = (isAARN = false) => yup.object().shape(getRules(isAARN));

export const getFormResolver = (isAARN = false) => yupResolver(getFormSchema(isAARN));
